<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header mb-0">
          <i class="fa fa-calendar-day"></i> Foglalás részletek <small></small>
        </h1>
      </div>
      <div class="ms-auto">
        <button
          class="btn btn-success btn-rounded px-4 rounded-pill"
          v-if="booking && booking.is_dirty == 1"
          @click="isDirtyUnset()"
          :disabled="loading"
        >
          <i
            :class="{ 'fa-envelope': !loading, 'fa-cog fa-spin': loading }"
            class="fa fa-lg me-2 ms-n2 text-success-900"
          ></i>
          Újra kiküldöm a díjbekérőt
        </button>
      </div>
    </div>
    <hr />
    <Loading v-if="loading"></Loading>
    <div v-else-if="!booking">
      <div class="row">
        <div class="col bg-white text-center p-4">
          Nem található foglalás ezzel az azonosítóval!<br />
          <button
            class="btn btn-success btn-rounded mt-4 px-4 rounded-pill"
            @click="backToBookings"
          >
            <i class="fa fa-arrow-left fa-lg me-2 ms-n2 text-success-900"></i>
            Vissza a foglalásokhoz
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-6">
          <panel title="Alap adatok" noButton="true">
            <template slot="header">
              <h4 class="panel-title">Alap adatok</h4>
              <help
                helpId="base_data_help"
                title="Alap adatok"
                text="A dátum választók segítségével szerkesztheti a foglalás idejét"
              ></help>
            </template>
            <Loading v-if="!booking || !user"></Loading>
            <div class="table-responsive" v-else>
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <th style="width: 50%">Foglalás azonosító</th>
                    <td>
                      <strong>{{ booking.id }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <th>Foglalás leadásának időpontja</th>
                    <td>{{ booking.created_at }}</td>
                  </tr>
                  <tr>
                    <th>Foglaló neve</th>
                    <td>{{ booking.user_name }}</td>
                  </tr>
                  <tr>
                    <th>Foglaló tagazonosítója</th>
                    <td>{{ booking.user_membership_id }}</td>
                  </tr>
                  <tr>
                    <th>Foglaló email címe</th>
                    <td>{{ booking.user_email }}</td>
                  </tr>
                  <tr>
                    <th>Foglaló telefonszáma</th>
                    <td>{{ booking.user_phone }}</td>
                  </tr>
                  <tr>
                    <th>Foglalás kezdete</th>
                    <td>
                      <!--<input type="date" max="2050-12-31" v-model="booking.arrive_at" class="form-control" @change="durationUpdated('arrive_at')" v-if="booking.status == 1 && user.role_id == 1">-->
                      <date-picker
                        :config="{ format: 'YYYY-MM-DD' }"
                        v-model="booking.arrive_at"
                        class="form-control"
                        @dp-change="durationUpdated('arrive_at')"
                        v-if="booking.status == 1 && user.role_id == 1"
                      ></date-picker>
                      <span v-else-if="booking.status == 5 && user.role_id == 1 && Date.parse(booking.arrive_at) > new Date()">
                        <span v-if="isBookingDateBeingEdited"><date-picker
                        :config="{ format: 'YYYY-MM-DD', minDate: new Date().toISOString().split('T')[0] }"
                        v-model="booking.arrive_at"
                        class="form-control"></date-picker>
                        <a class="btn btn-success" @click="bookingStartDateUpdated()">
                          <i class="fa fa-check"></i>
                        </a>
                        <a class="btn btn-secondary" @click="cancelBookingDateEdit()">
                          <i class="fa fa-times"></i>
                        </a>
                      </span>
                        <span v-else>
                          {{ booking.arrive_at }}
                          <a class="btn btn-info btn-xs mx-1" @click="toggleEditBookingDate()">
                            <i class="fa fa-edit"></i>
                          </a>
                        </span>
                      </span>
                      <span v-else>{{ booking.arrive_at }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>Foglalás vége</th>
                    <td>
                      <!--<input type="date" max="2050-12-31" v-model="booking.leave_at" class="form-control" :min="momentIncrementedToMinimumEnd(booking.arrive_at)" @change="durationUpdated('leave_at')" v-if="booking.status == 1 && user.role_id == 1">-->
                      <date-picker
                        :config="{
                          format: 'YYYY-MM-DD',
                          minDate: momentIncrementedToMinimumEnd(
                            booking.arrive_at
                          ),
                        }"
                        v-model="booking.leave_at"
                        class="form-control"
                        @dp-change="durationUpdated('leave_at')"
                        v-if="booking.status == 1 && user.role_id == 1"
                      ></date-picker>
                      <span v-else>{{ booking.leave_at }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th>Éjszakák száma</th>
                    <td>{{ booking.nights }}</td>
                  </tr>
                  <tr>
                    <th>Vendégház</th>
                    <td>{{ booking.guesthouse.name }}</td>
                  </tr>
                  <tr v-if="booking.coupon">
                    <th>Felhasznált kupon</th>
                    <td>
                      {{ booking.coupon.name }} ({{ booking.coupon.value
                      }}{{
                        booking.coupon.discount_type == "fixed" ? " Ft" : "%"
                      }})
                    </td>
                  </tr>
                  <tr>
                    <th>Lemondható</th>
                    <td>
                      <v-select
                        class="bg-white"
                        v-model="booking.non_refundable"
                        :options="[
                          { id: 0, name: 'Lemondható' },
                          { id: 1, name: 'Nem lemondható' },
                        ]"
                        :reduce="(option) => option.id"
                        :clearable="false"
                        :disabled="booking.status != 1"
                        @option:selected="bookingUpdate"
                        label="name"
                      ></v-select>
                    </td>
                  </tr>
                  <tr>
                    <th>Foglalás ára</th>
                    <td>{{ booking.original_price || booking.price }} Ft</td>
                  </tr>
                  <tr>
                    <th>Ár felülbírálása</th>
                    <td>
                      <input
                        class="pb-1"
                        type="text"
                        v-model="booking.price"
                        @input="
                          booking.price = booking.price.replace(/[^0-9]/g, '')
                        "
                      />
                      <button
                        class="btn btn-success btn-xs mx-1"
                        @click="priceUpdate"
                        v-if="user.role_id == 1 && booking.status == 1"
                      >
                        Ár mentése
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <th>Fizetésmód</th>
                    <td>{{ booking.payment_method_name }}</td>
                  </tr>
                  <tr>
                    <th>Állapot</th>
                    <td>
                      {{ booking.status_name }}
                      <button
                        @click="cancelBooking"
                        v-if="
                          [1, 5].includes(booking.status) &&
                          Date.parse(booking.arrive_at) > new Date() &&
                          user.role_id == 1
                        "
                        class="btn btn-danger btn-xs float-end"
                      >
                        Foglalás lemondása
                      </button>
                      <button
                        @click="sendVoucher"
                        v-if="
                          booking.status == 5 &&
                          Date.parse(booking.arrive_at) > new Date()
                        "
                        class="btn btn-success btn-xs float-end"
                      >
                        Voucher újraküldése
                      </button>
                    </td>
                  </tr>

                  <tr v-if="[3, 15, 16, 17, 19].includes(booking.status)">
                    <th>Lemondás időpontja</th>
                    <td>
                      {{ booking.cancelled_at | moment("YYYY-MM-DD HH:mm") }}
                    </td>
                  </tr>
                  <tr v-if="booking.status == 19">
                    <th>Visszautalás összege</th>
                    <td>
                      {{ booking.refund_amount.toLocaleString("hu-HU") }} Ft
                    </td>
                  </tr>
                  <tr
                    v-if="
                      booking.refund_amount != booking.price &&
                      booking.status == 19
                    "
                  >
                    <th>Visszatartott összeg</th>
                    <td>
                      {{
                        (booking.price - booking.refund_amount).toLocaleString(
                          "hu-HU"
                        )
                      }}
                      Ft
                    </td>
                  </tr>
                  <tr v-if="Date.parse(booking.arrive_at) > new Date()">
                    <th></th>
                    <td>
                      <button
                        class="btn btn-success btn-rounded px-4 rounded-pill"
                        :disabled="loading"
                        @click="isDirtyUnset()"
                      >
                        <i
                          :class="{
                            'fa-envelope': !loading,
                            'fa-cog fa-spin': loading,
                          }"
                          class="fa fa-lg me-2 ms-n2 text-success-900"
                        ></i>
                        Díjbekérő újraküldése
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </panel>
        </div>
        <div class="col-md-6">
          <panel title="Szobák hozzáadása">
            <div class="row text-end">
              <help
                helpId="addroom_help"
                title="Szoba hozzáadás"
                text="A szabad szobák melletti + gombbal hozzáadhatja a foglaláshoz a kívánt szobákat"
              ></help>
            </div>
            <div class="row">
              <Loading title="Szobák betöltése" v-if="!rooms"></Loading>
              <div v-else>
                <p>
                  A választott időpontban a következő
                  {{
                    booking.guesthouse.apartment == 1 ? "apartmanok" : "szobák"
                  }}
                  szabadok:
                </p>
                <div class="table-responsive">
                  <table class="table table-hover align-middle">
                    <thead>
                      <tr>
                        <th
                          v-if="booking.status == 1 && user.role_id == 1"
                        ></th>
                        <th>Szám</th>
                        <th>Kapacitás</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(room, id) in rooms" :key="id">
                        <td
                          style="white-space: nowrap"
                          v-if="booking.status == 1 && user.role_id == 1"
                        >
                          <button
                            class="btn btn-success btn-xs"
                            @click="addRoom(room.id)"
                          >
                            <i class="fa fa-plus"></i>
                          </button>
                        </td>
                        <td>{{ room.number }}</td>
                        <td>{{ room.capacity }} ágyas</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </panel>
        </div>
        <div class="col-12">
          <panel title="Vendégek">
            <Loading v-if="!booking"></Loading>
            <div v-else>
              <div class="text-end">
                <help helpId="guestPanel_help" title="Vendégek">
                  <template v-slot:text>
                    <p>
                      szerkesztheti a felhasználókat és a szobákat az alábbi
                      módokon:
                    </p>
                    <ul>
                      <li class="mb-1">
                        <button class="btn btn-danger btn-xs" disabled>
                          <i class="fa fa-trash"></i>
                        </button>
                        szoba/vendég törlés
                      </li>
                      <li class="mb-1">
                        <button class="btn btn-green btn-xs" disabled>
                          <i class="fa fa-edit"></i>
                        </button>
                        vendég adatainak szerkesztése, <br />
                        <button class="btn btn-lime btn-xs mx-1" disabled>
                          <i class="fa fa-check"></i></button
                        >: vendég szerkesztés mentése <br />
                        <button class="btn btn-secondary btn-xs mx-1" disabled>
                          <i class="fa fa-times"></i></button
                        >: vendég szerkesztés elvetése
                      </li>
                    </ul>
                    <p>
                      Ezen műveletek mind a foglalás árának újraszámolását
                      eredményezik, így új díjbekérő kiküldése szükséges
                    </p>
                  </template>
                </help>
              </div>
              <div class="table-responsive">
                <table
                  class="table table-bordered"
                  v-if="booking.status == 1 && user.role_id == 1"
                >
                  <thead>
                    <tr>
                      <th>Szoba</th>
                      <th>Vendég</th>
                      <th>Születési idő</th>
                      <th>Kedvezmény</th>
                      <th class="text-end" colspan="2">Műveletek</th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="(room, room_id) in booking.rooms"
                    :key="room_id"
                  >
                    <tr v-for="(user, id) in room.users" :key="id">
                      <th
                        class="align-middle"
                        :rowspan="
                          room.users.length == room.capacity
                            ? room.capacity
                            : room.users.length + 1
                        "
                        v-if="id == 0"
                      >
                        {{ room.room }} ({{ room.users.length }}/{{
                          room.capacity
                        }})
                      </th>
                      <template
                        v-if="edit_user_object.guest_id == user.guest_id"
                      >
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            v-model="edit_user_object.name"
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            max="2050-12-31"
                            class="form-control"
                            v-model="edit_user_object.date_of_birth"
                          />
                        </td>
                        <td>
                          <Loading mini v-if="!guest_categories"></Loading>
                          <v-select
                            v-else
                            v-model="edit_user_object.guest_category_id"
                            :options="guest_categories"
                            :reduce="(option) => option.id"
                            label="name"
                          >
                            <template #search="{ attributes, events }">
                              <input
                                class="vs__search"
                                :required="!edit_user_object.guest_category_id"
                                v-bind="attributes"
                                v-on="events"
                                :placeholder="
                                  !edit_user_object.guest_category_id
                                    ? 'Válassz Kedvezményt!'
                                    : ''
                                "
                              />
                            </template>
                          </v-select>
                        </td>
                        <td class="text-end">
                          <button
                            class="btn btn-lime btn-xs mx-1"
                            @click="updateGuest"
                          >
                            <i class="fa fa-check"></i>
                          </button>
                          <button
                            class="btn btn-secondary btn-xs mx-1"
                            @click="resetEdit"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </td>
                      </template>
                      <template v-else>
                        <td>{{ user.name }}</td>
                        <td>{{ user.date_of_birth }}</td>
                        <td>{{ user.guest_category }}</td>
                        <td class="text-end">
                          <button
                            class="btn btn-green btn-xs mx-1"
                            @click="setEdit(user)"
                          >
                            <i class="fa fa-edit"></i>
                          </button>
                          <button
                            class="btn btn-danger btn-xs mx-1"
                            @click="confirmDelete(user.guest_id, 'guest')"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </template>
                      <td
                        class="align-middle text-center"
                        :rowspan="
                          room.users.length == room.capacity
                            ? room.capacity
                            : room.users.length + 1
                        "
                        v-if="id == 0"
                      >
                        <button
                          @click="confirmDelete(room.room_id, 'room')"
                          class="btn btn-danger btn-xs"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="room.users.length == 0">
                      <th class="align-middle" rowspan="2">
                        {{ room.room }} ({{ room.users.length }}/{{
                          room.capacity
                        }})
                      </th>
                      <td colspan="4" class="text-center">
                        Ez a szoba üres, adjon hozzá vendégeket vagy törölje a
                        szobát
                      </td>
                      <th class="align-middle text-center" rowspan="2">
                        <button
                          @click="confirmDelete(room.room_id, 'room')"
                          class="btn btn-danger btn-xs"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </th>
                    </tr>
                    <tr v-if="room.users.length < room.capacity">
                      <td colspan="4" class="text-center">
                        <button
                          class="btn btn-xs btn-success"
                          v-b-modal.addGuestModal
                          @click="prepareAddUserModal(room.room_id)"
                        >
                          <i class="fa fa-plus"></i> {{ room.room }} vendég
                          hozzáadása
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="table table-bordered table-hover" v-else>
                  <thead>
                    <tr>
                      <th>Szoba</th>
                      <th>Vendég</th>
                      <th>Születési idő</th>
                      <th>Kedvezmény</th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="(room, room_id) in booking.rooms"
                    :key="room_id"
                  >
                    <tr v-for="(user, id) in room.users" :key="id">
                      <th
                        class="align-middle"
                        :rowspan="room.users.length"
                        v-if="id == 0"
                      >
                        {{ room.room }} ({{ room.users.length }}/{{
                          room.capacity
                        }})
                      </th>
                      <td>{{ user.name }}</td>
                      <td>{{ user.date_of_birth }}</td>
                      <td>{{ user.guest_category }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </panel>
        </div>
      </div>
    </div>
    <b-modal
      id="addGuestModal"
      cancel-variant="default"
      @cancel="closeAddModal()"
      @ok="addSubmit"
      ok-title="Hozzáadás"
      cancel-title="Mégse"
      :ok-disabled="loading"
    >
      <template slot="modal-header">
        <h4 class="modal-title">Új Vendég</h4>
        <a class="btn-close" @click="closeAddModal()"></a>
      </template>
      <Loading v-if="!add_user_object"></Loading>
      <Loading v-else-if="loading == true" title="Hozzáadás"></Loading>
      <form v-else @submit.prevent="addGuest()">
        <div class="form-group">
          <label class="form-label">Név</label>
          <input
            type="text"
            class="form-control"
            v-model="add_user_object.name"
            required
          />
        </div>
        <div class="form-group">
          <label class="form-label">Születési dátum</label>
          <input
            type="date"
            max="2050-12-31"
            class="form-control"
            v-model="add_user_object.date_of_birth"
            required
          />
        </div>
        <div class="form-group">
          <label class="form-label">Kedvezmény</label>
          <Loading mini v-if="!guest_categories"></Loading>
          <v-select
            v-else
            v-model="add_user_object.guest_category_id"
            :options="guest_categories"
            :reduce="(option) => option.id"
            label="name"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                :required="!add_user_object.guest_category_id"
                v-bind="attributes"
                v-on="events"
                :placeholder="
                  !add_user_object.guest_category_id
                    ? 'Válassz Kedvezményt!'
                    : ''
                "
              />
            </template>
          </v-select>
        </div>
        <button
          class="d-none"
          type="submit"
          ref="add_guest_submit_button"
        ></button>
      </form>
    </b-modal>
  </div>
</template>

<script>
import Booking from "../../apis/Booking";
import Setting from "../../apis/Setting";
import Confirmation from "../../apis/Confirmation";
import moment from "moment";

export default {
  data() {
    return {
      rooms: null,
      booking: null,
      edit_user_object: {},
      guest_categories: null,
      add_user_object: null,
      errors: [],
      loading: false,
      isBookingDateBeingEdited: false,
      originalBookingArriveAt: null,
    };
  },
  created() {
    Booking.show(this.$route.params.id)
      .then((response) => {
        this.booking = response.data;
        this.booking.original_price = this.booking.price;
        this.getRooms();
      })
      .catch(() => {
        console.log("baszdmeg");
      });

    Setting.guestCategories().then((response) => {
      this.guest_categories = response.data;
    });
  },
  computed: {
    getrooms_object() {
      return {
        guest_house_id: this.booking.guesthouse.id,
        arrive_at: this.booking.arrive_at,
        leave_at: this.booking.leave_at,
      };
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    cancelBooking() {
      Booking.cancel(this.booking.hashed_id).then((response) => {
        this.booking = response.data;
        this.getRooms();
      });
    },
    sendVoucher() {
      Booking.sendVoucher(this.booking.id);
    },
    priceUpdate() {
      Booking.priceUpdate(this.booking.id, this.booking.price);
      this.booking.is_dirty = 1;
    },
    isDirtyUnset() {
      this.loading = true;
      Booking.isDirtyUnset(this.booking.id)
        .then(() => {
          this.booking.is_dirty = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.add_guest_submit_button.click();
    },
    addGuest() {
      if (
        this.diffInYears(this.add_user_object.date_of_birth) > 2 &&
        [3, 6].includes(this.add_user_object.guest_category_id)
      ) {
        Confirmation.swalErrorMessage(
          "csak 0-2 évesekre alkalmazható a 0-2 éves kedvezmény"
        );
      } else {
        Booking.addGuest(this.booking.id, this.add_user_object).then(
          (response) => {
            this.booking = response.data;
            this.closeAddModal();
          }
        );
      }
    },
    closeAddModal() {
      this.add_user_object = false;
      this.errors = [];
      this.$bvModal.hide("addGuestModal");
    },
    prepareAddUserModal(room_id) {
      this.add_user_object = {
        room_id: room_id,
      };
    },
    diffInYears(date) {
      return moment(new Date()).diff(moment(date), "years");
    },
    confirmDelete(id, type) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          if (type == "room") {
            this.deleteRoom(id);
          } else if (type == "guest") {
            this.deleteGuest(id);
          }
        }
      });
    },
    deleteRoom(id) {
      Booking.deleteRoom(this.booking.id, { room_id: id }).then((response) => {
        this.booking = response.data;
        this.getRooms();
      });
    },
    deleteGuest(id) {
      Booking.deleteGuest(this.booking.id, { guest_id: id }).then(
        (response) => {
          this.booking = response.data;
        }
      );
    },
    updateGuest() {
      if (
        this.diffInYears(this.edit_user_object.date_of_birth) > 2 &&
        [3, 6].includes(this.edit_user_object.guest_category_id)
      ) {
        Confirmation.swalErrorMessage(
          "csak 0-2 évesekre alkalmazható a 0-2 éves kedvezmény"
        );
      } else {
        Booking.updateGuest(this.booking.id, this.edit_user_object).then(
          (response) => {
            this.booking = response.data;
            this.resetEdit();
          }
        );
      }
    },
    addRoom(id) {
      Booking.addRoom(this.booking.id, { room_id: id }).then((response) => {
        this.booking = response.data;
        this.getRooms();
      });
    },
    setEdit(user) {
      this.edit_user_object = {
        name: user.name,
        date_of_birth: user.date_of_birth,
        guest_category_id: user.guest_category_id,
        guest_id: user.guest_id,
      };
    },
    resetEdit() {
      this.edit_user_object = {};
    },
    momentIncrementedToMinimumEnd(arrive_at) {
      return moment(arrive_at).add(1, "days").format("YYYY-MM-DD");
      /* 				if(this.booking.house == 1){
					return moment(arrive_at).add(7,'days').format('YYYY-MM-DD'); 
				}else{
					return moment(arrive_at).add(3,'days').format('YYYY-MM-DD'); 
				} */
    },
    durationUpdated(field) {
      Booking.durationUpdated(field, this.$route.params.id, {
        arrive_at: this.booking.arrive_at,
        leave_at: this.booking.leave_at,
      }).then((response) => {
        this.booking = response.data;
      });
    },
    getRooms() {
      Booking.getRooms(this.getrooms_object).then((response) => {
        this.rooms = response.data;
      });
    },
    backToBookings() {
      this.$router.push("/bookings");
    },
    bookingUpdate() {
      Booking.update(this.booking.id, {
        non_refundable: this.booking.non_refundable,
      });
    },
    cancelBookingDateEdit() {
      if (this.booking && this.originalBookingArriveAt) {
        this.booking.arrive_at = this.originalBookingArriveAt;
      }

      this.isBookingDateBeingEdited = false;
      this.originalBookingArriveAt = null;
    },
    toggleEditBookingDate() {
      if (this.isBookingDateBeingEdited) {
        this.isBookingDateBeingEdited = false;
        this.originalBookingArriveAt = null;
      } else {
        this.originalBookingArriveAt = this.booking
          ? this.booking.arrive_at
          : null;
        this.isBookingDateBeingEdited = true;
      }
    },
    bookingStartDateUpdated() {
      if (this.booking) {
        Booking.updateBookingStartDate(this.booking.id, {
          arrive_at: this.booking.arrive_at,
        })
          .then((response) => {
            this.booking = response.data;
            this.isBookingDateBeingEdited = false;
            this.originalBookingArriveAt = null;
          })
          .catch((error) => {
            if (error && error.response && error.response.status === 422) {
              this.cancelBookingDateEdit();
              Confirmation.swalErrorMessage(
                "A foglalás nem mozgatható a kért időpontra."
              );
              return;
            }

            throw error;
          });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.booking && this.booking.is_dirty == 1) {
      Confirmation.swalCustomConfirm(
        "Biztos elhagyod az oldalt?",
        "Igen",
        "nem küldtél még ki új díjbekérőt"
      ).then((response) => {
        if (response.isConfirmed === true) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  
};
</script>
